import { LicenseInfo } from '@mui/x-license-pro';

export const registerMuiLicense = () => {
  LicenseInfo.setLicenseKey(
    '5e536e7a7b6aa3934279da7214260c19Tz03NzYzOCxFPTE3MzAxMjgyMTAwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y'
  );
};
